/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Status_ExistsInputs */



/**
* | output |
* | --- |
* | "Already on team" |
*
* @param {Team_Manager_Import_Status_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_status_exists = /** @type {((inputs?: Team_Manager_Import_Status_ExistsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Status_ExistsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déjà dans l'équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereits im Team")
	if (locale === "it") return /** @type {LocalizedString} */ ("Già nel team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уже в команде")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ya está en el equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已在团队中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("既にチームに参加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहले से टीम में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Já está na equipa")
	return /** @type {LocalizedString} */ ("Already on team")
});